import { render, staticRenderFns } from "./LoginGhost.vue?vue&type=template&id=00be6c08"
import script from "./LoginGhost.vue?vue&type=script&lang=js"
export * from "./LoginGhost.vue?vue&type=script&lang=js"
import style0 from "./LoginGhost.vue?vue&type=style&index=0&id=00be6c08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports